export const environment = {
  production: true,
  serverUrl: 'https://gsfpkapi.educian.com/',
  //serverUrl: 'https://gsfapi.educian.com/'
  //serverUrl:'https://gsfprodapi.educian.com/',
  //serverUrl:'https://gsfapidev.educian.com/',
  //serverUrl: 'https://gsftestapi.educian.com/',
  forgetPasswordReturnUrl: 'reset-password',
  recaptcha: {
    siteKey: '6LeBiuciAAAAAHViIkJulVOeHFy1ZtGwD5yJKNvf'
  },
};
